import { useEffect, useState } from 'react';
import { isFieldForCategory, isFieldForListingType } from '../../../../util/fieldHelpers';
import css from './SectionPopularCars.module.css';
import { getUserType } from '../../../../util/getListings';

const userTypes = {
  company: 'Profesional',
  private: 'Privado',
};

const PopularCar = ({ config, car, key }) => {
  const [userType, setUserType] = useState('');
  useEffect(() => {
    (async () => {
      const data = await getUserType(car.authorId);
      setUserType(userTypes[data]);
    })();
  }, []);

  const publicData = car.publicData;
  const pickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;
    const listingType = publicData.listingType;
    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;
    const publicDataValue = publicData[key];
    const metadataValue = car.metadata[key];
    const value = typeof publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const findSelectedOption = enumValue => enumOptions?.find(o => enumValue === `${o.option}`);
      const getBooleanMessage = value =>
        value
          ? intl.formatMessage({ id: 'SearchPage.detailYes' })
          : intl.formatMessage({ id: 'SearchPage.detailNo' });
      const optionConfig = findSelectedOption(value);
      return schemaType === 'enum'
        ? filteredConfigs.concat({ key, value: optionConfig?.label, label })
        : schemaType === 'boolean'
        ? filteredConfigs.concat({ key, value: getBooleanMessage(value), label })
        : schemaType === 'long'
        ? filteredConfigs.concat({ key, value, label })
        : key === 'vin'
        ? filteredConfigs.concat({ key, value, label })
        : filteredConfigs;
    }
    return filteredConfigs;
  };
  const existingListingFields = config.reduce(pickListingFields, []);
  const Etiqueta = existingListingFields.find(el => el.key === 'EtiquetaAmbiental');
  const type = existingListingFields.find(el => el.key === 'type');
  const transmission = existingListingFields.find(el => el.key === 'transmission');
  const bodyType = existingListingFields.find(el => el.key === 'bodyType');
  const mileage = existingListingFields.find(el => el.key === 'mileage');

  return (
    <div key={key} className={css.car}>
      <div>
        <a href={car.link}>
          <img src={car.imageUrl} />
        </a>
        <h4 className={css.car_title}>{car.title}</h4>
        <p className={css.car_price}>
          €{car.price.toString().slice(0, -3)}.{car.price.toString().slice(-3)}
        </p>
        <ul className={css.car_list}>
          {publicData.year && <li>{publicData.year}</li>}
          {Etiqueta && <li>Etiqueta {Etiqueta.value}</li>}
          {type && <li>{type.value}</li>}
          {transmission && <li>{transmission.value}</li>}
          {userType && <li>{userType}</li>}
          {bodyType && <li>{bodyType.value}</li>}
        </ul>
      </div>
      <div>
        {mileage && (
          <div className={css.car_mileage}>
            <span className={css.car_mileage_first}>{mileage.label}:</span>
            <span className={css.car_mileage_last}>{publicData.mileage} km</span>
          </div>
        )}

        <a href={car.link} className={css.car_button}>
          Ver anuncio
        </a>
      </div>
    </div>
  );
};

export default PopularCar;
